import React, { useEffect } from "react";
import { useQuery } from "../Hooks/useQuery";
import httpService from "../Service/httpService";
import { toast } from "react-toastify";
import useModalWindowControls from "../Hooks/useModal";
import CongratsPopUp from "../Common/CongratsPopUp";

const StripeSessionGuard: React.FC = () => {
  const sessionId = useQuery().get("session_id");
  const successfullySubscribedModal = useModalWindowControls();

  useEffect(() => {
    if (sessionId) {
      const checkSession = async () => {
        try {
          const response: any = await httpService.get(
            `check-session?session_id=${sessionId}`
          );

          if (response?.data?.session) {
            successfullySubscribedModal.openModal(response?.data?.session);
            localStorage.setItem("Nurture_user_data", JSON.stringify(response?.data?.user));
          } else {
            toast.error(response?.message || "Something went wrong");
          }

          return;
        } catch (err: any) {
          toast.error(err?.message);
        }
      };

      checkSession();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  const isGiftCard =
    successfullySubscribedModal?.openModalData?.transaction_type === "giftcard";

  return (
    <CongratsPopUp
      closeModal={successfullySubscribedModal.closeModal}
      isVisible={successfullySubscribedModal.isVisible}
    >
      <h3>Thank you!</h3>
      {isGiftCard ? (
        <p>
          Thank you for giving the gift of support! You will receive an email
          confirmation shortly with the details of your purchase.
        </p>
      ) : (
        <p>
          Your current transaction status is{" "}
          <b>
            {successfullySubscribedModal?.openModalData?.payment_status ||
              "processing"}
          </b>
          .
          <br />
          You can check your payment details in the profile section.
        </p>
      )}
    </CongratsPopUp>
  );
};

export default StripeSessionGuard;
